//
//
//
//
//
//
//
//
//
//
//

import XLSX from 'xlsx';
export default {
  props: {
    beforeUpload: Function,
    // eslint-disable-line
    onSuccess: Function,
    // eslint-disable-line
    getFileObject: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    buttonSize: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      excelData: {
        header: null,
        results: null
      }
    };
  },
  methods: {
    generateData: function generateData(_ref) {
      var header = _ref.header,
        results = _ref.results,
        file = _ref.file,
        fileName = _ref.fileName;
      this.excelData.header = header;
      this.excelData.results = results;
      this.excelData.fileName = fileName || file && file.name || '';
      this.onSuccess && this.onSuccess(this.excelData);
    },
    handleDrop: function handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.loading) return;
      var files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$message.error('Only support uploading one file!');
        return;
      }
      var rawFile = files[0]; // only use files[0]

      if (!this.isExcel(rawFile)) {
        this.$message.error('Only supports upload .xlsx, .xls, .csv suffix files');
        return false;
      }
      this.upload(rawFile);
      e.stopPropagation();
      e.preventDefault();
    },
    handleDragover: function handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    },
    handleUpload: function handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick: function handleClick(e) {
      var files = e.target.files;
      var rawFile = files[0]; // only use files[0]
      if (!rawFile) return;
      this.getFileObject(rawFile);
      this.upload(rawFile);
    },
    upload: function upload(rawFile) {
      this.$refs['excel-upload-input'].value = null; // fix can't select the same excel

      if (!this.beforeUpload) {
        this.readerData(rawFile);
        return;
      }
      var before = this.beforeUpload(rawFile);
      if (before) {
        this.readerData(rawFile);
      }
    },
    readerData: function readerData(rawFile) {
      var _this = this;
      this.loading = true;
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var data = e.target.result;
          var workbook = XLSX.read(data, {
            type: 'array'
          });
          var firstSheetName = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[firstSheetName];
          var header = _this.getHeaderRow(worksheet);
          // 保留空单元格与空行：defval 统一为空字符串，blankrows 保留空行
          var results = XLSX.utils.sheet_to_json(worksheet, {
            defval: '',
            raw: true,
            blankrows: true
          });
          _this.generateData({
            header: header,
            results: results,
            file: rawFile,
            fileName: rawFile && rawFile.name
          });
          _this.loading = false;
          resolve();
        };
        reader.readAsArrayBuffer(rawFile);
      });
    },
    getHeaderRow: function getHeaderRow(sheet) {
      var headers = [];
      var range = XLSX.utils.decode_range(sheet['!ref']);
      var C;
      var R = range.s.r;
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        var cell = sheet[XLSX.utils.encode_cell({
          c: C,
          r: R
        })];
        /* find the cell in the first row */
        var hdr = 'UNKNOWN ' + C; // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    isExcel: function isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    }
  }
};